import styled from "@emotion/styled";

export const StyledMainLayout = styled.div`
  .main-content {
    /* background-color: ${({ theme }) => theme.palette.custom.toledo}; */
    /* height: 100vh; */
  }
`;
